
export const platform = {
  "title": "MSP Platform Admin",
  "subtitle": "คอนโซลผู้ดูแลระบบ (Super Admin)",
  "loading": "กำลังดึงข้อมูล...",
  "systemError": "เกิดข้อผิดพลาดระบบ",
  "retry": "ลองใหม่",
  "tabs": {
      "overview": "ภาพรวม (Overview)",
      "plans": "แพ็กเกจ (Plans)",
      "marketing": "AI การตลาด (Marketing)",
      "logs": "ประวัติความปลอดภัย (Security Logs)",
      "diagnostics": "ตรวจสอบระบบ (Diagnostics)",
      "clearing": "ระบบเคลียร์ยอด (Clearing)"
  },
  "stats": {
      "mrr": "รายรับต่อเดือน (MRR)",
      "stores": "จำนวนคลินิก",
      "patients": "ผู้ป่วยรวมทั้งระบบ",
      "transactions": "ยอดธุรกรรมทั้งหมด"
  },
  "storeTable": {
      "title": "จัดการคลินิก (Clinic Management)",
      "name": "ชื่อคลินิก",
      "plan": "แพ็กเกจ",
      "wallet": "กระเป๋าเงิน",
      "status": "สถานะ",
      "action": "จัดการ",
      "searchPlaceholder": "ค้นหาร้านค้า..."
  },
  "tools": {
      "backup": "สำรองฐานข้อมูล (Backup)",
      "backupDesc": "สร้างไฟล์สำรองข้อมูล (SQL Dump) ของระบบทั้งหมด",
      "downloadBackup": "ดาวน์โหลดไฟล์สำรอง",
      "reconcile": "ตรวจสอบการชำระเงิน",
      "reconcileDesc": "ตรวจสอบสถานะการชำระเงินด้วยตนเอง",
      "check": "ตรวจสอบ"
  }
};
